import { Base } from "../core/base.model";

export class ProductoCliente extends Base{
    id_producto: number;
	id_cliente: number;
    producto: string;
    estatus: string;
    clave_producto: string;

    nuevoProductos: boolean;

}